import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
export const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { initialized, user } = useAppSelector((state) => state.auth);
    if (!initialized) {
        return (_jsx("div", { className: "flex min-h-screen items-center justify-center px-4", children: _jsxs("div", { className: "glass-panel-strong w-full max-w-md rounded-[32px] p-6", children: [_jsx("div", { className: "skeleton-shimmer h-6 w-32 rounded-xl" }), _jsx("div", { className: "skeleton-shimmer mt-4 h-12 w-full rounded-2xl" }), _jsx("div", { className: "skeleton-shimmer mt-3 h-12 w-5/6 rounded-2xl" })] }) }));
    }
    if (!user) {
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: location.pathname } });
    }
    return _jsx(_Fragment, { children: children });
};
